"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
exports.top = function (comp) { return comp.top; };
exports.left = function (comp) { return comp.left; };
exports.bottom = function (comp) { return comp.top + comp.height; };
exports.height = function (comp) { return comp.height; };
exports.fitToContentHeight = function (container) { return Boolean(container.fitToContentHeight); };
exports.getContainerHeight = function (container) { return _.max([container.height || 0, container.minHeight || 0]); };
//# sourceMappingURL=compLayoutUtils.js.map